import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { selectCanGoToStep } from '../pages/password-recovery/store/password-recovery.selectors';

export const passwordRecoveryStepGuard: CanMatchFn = (
  route: Route,
  _segments: UrlSegment[]
) => {
  const router = inject(Router);
  const store = inject(Store);
  const minStep = (route.data?.['minStep'] as number) ?? 1;

  return store.select(selectCanGoToStep).pipe(
    take(1),
    map(canGoToStep =>
      canGoToStep >= minStep
        ? true
        : router.createUrlTree(['/auth/password-recovery/verify-username'])
    )
  );
};
